// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CIN-6274 lead-salvage modal.
   Reuses .modal-overlay / .modal-content from Scheduler.css and the --primary-*
   branding vars; only salvage-specific overrides live here. */

/* Sit above the scheduler modal (which is also .modal-overlay, z-index 1000). */
.salvage-modal-overlay {
  z-index: 1100;
}

.salvage-modal-content {
  position: relative;
  width: 90%;
  max-width: 499px;
  /* Override the scheduler modal's tall min/max height for this compact modal. */
  min-height: 0;
  max-height: none;
  border-radius: 16px; /* borderradius-lg */
  padding: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Scheduler.css forces .modal-content to height/max-height 100vh !important below
   its mobile-fullscreen breakpoint. The salvage modal must stay a compact centered
   card at every width, so counter it with a higher-specificity !important rule
   instead of mirroring that breakpoint here. */
.modal-content.salvage-modal-content {
  width: 90%;
  max-width: 499px;
  height: auto !important;
  max-height: 90vh !important;
  border-radius: 16px;
}

.salvage-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  padding: 4px;
  color: #0b0c0e;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.salvage-close:hover {
  background-color: #f0f0f0;
}

.salvage-title {
  margin: 0;
  padding-right: 32px; /* keep clear of the close icon */
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  color: #0b0c0e;
}

.salvage-subtitle {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #333;
}

.salvage-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
}

.salvage-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.salvage-input {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #979daa; /* border/secondary */
  border-radius: 8px; /* borderradius-md */
  font-size: 16px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.2s;
  background-color: white;
}

.salvage-input::placeholder {
  color: #b3b7c1; /* text/disabled tone */
}

.salvage-input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.salvage-required {
  position: absolute;
  right: 16px;
  color: #d32f2f;
  font-size: 18px;
  pointer-events: none;
}

.salvage-error {
  color: #c53030;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
}

.salvage-submit {
  align-self: center;
  min-width: 213.5px;
  margin-top: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  color: var(--primary-button-text);
  background-color: var(--primary-button-bg);
  transition: background-color 0.2s, opacity 0.2s;
}

.salvage-submit:hover:not(:disabled) {
  background-color: var(--primary-color-dark);
}

.salvage-submit:disabled {
  background-color: #d5d7dd; /* background/disabled */
  color: #b3b7c1; /* text/disabled */
  cursor: not-allowed;
}

.salvage-dismiss {
  align-self: center;
  background: none;
  border: none;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  color: #0b0c0e;
  cursor: pointer;
}

.salvage-dismiss:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .salvage-modal-content {
    /* Keep the salvage modal a centered card even where the scheduler modal
       goes full-screen. */
    width: 90%;
    height: auto !important;
    max-height: 90vh !important;
    border-radius: 16px;
    padding: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LeadSalvageModal.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D,gFAAgF;AAChF;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,+EAA+E;EAC/E,aAAa;EACb,gBAAgB;EAChB,mBAAmB,EAAE,oBAAoB;EACzC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;+CAG+C;AAC/C;EACE,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB,EAAE,iCAAiC;EACtD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB,EAAE,oBAAoB;EACxC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iCAAiC;EACjC,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,cAAc,EAAE,kBAAkB;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE;0BACsB;IACtB,UAAU;IACV,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;EACf;AACF","sourcesContent":["/* CIN-6274 lead-salvage modal.\n   Reuses .modal-overlay / .modal-content from Scheduler.css and the --primary-*\n   branding vars; only salvage-specific overrides live here. */\n\n/* Sit above the scheduler modal (which is also .modal-overlay, z-index 1000). */\n.salvage-modal-overlay {\n  z-index: 1100;\n}\n\n.salvage-modal-content {\n  position: relative;\n  width: 90%;\n  max-width: 499px;\n  /* Override the scheduler modal's tall min/max height for this compact modal. */\n  min-height: 0;\n  max-height: none;\n  border-radius: 16px; /* borderradius-lg */\n  padding: 32px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Scheduler.css forces .modal-content to height/max-height 100vh !important below\n   its mobile-fullscreen breakpoint. The salvage modal must stay a compact centered\n   card at every width, so counter it with a higher-specificity !important rule\n   instead of mirroring that breakpoint here. */\n.modal-content.salvage-modal-content {\n  width: 90%;\n  max-width: 499px;\n  height: auto !important;\n  max-height: 90vh !important;\n  border-radius: 16px;\n}\n\n.salvage-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: none;\n  border: none;\n  padding: 4px;\n  color: #0b0c0e;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.salvage-close:hover {\n  background-color: #f0f0f0;\n}\n\n.salvage-title {\n  margin: 0;\n  padding-right: 32px; /* keep clear of the close icon */\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #0b0c0e;\n}\n\n.salvage-subtitle {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #333;\n}\n\n.salvage-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.salvage-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.salvage-input {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #979daa; /* border/secondary */\n  border-radius: 8px; /* borderradius-md */\n  font-size: 16px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n  background-color: white;\n}\n\n.salvage-input::placeholder {\n  color: #b3b7c1; /* text/disabled tone */\n}\n\n.salvage-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.salvage-required {\n  position: absolute;\n  right: 16px;\n  color: #d32f2f;\n  font-size: 18px;\n  pointer-events: none;\n}\n\n.salvage-error {\n  color: #c53030;\n  font-size: 14px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.salvage-submit {\n  align-self: center;\n  min-width: 213.5px;\n  margin-top: 8px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  color: var(--primary-button-text);\n  background-color: var(--primary-button-bg);\n  transition: background-color 0.2s, opacity 0.2s;\n}\n\n.salvage-submit:hover:not(:disabled) {\n  background-color: var(--primary-color-dark);\n}\n\n.salvage-submit:disabled {\n  background-color: #d5d7dd; /* background/disabled */\n  color: #b3b7c1; /* text/disabled */\n  cursor: not-allowed;\n}\n\n.salvage-dismiss {\n  align-self: center;\n  background: none;\n  border: none;\n  padding: 4px 8px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0b0c0e;\n  cursor: pointer;\n}\n\n.salvage-dismiss:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 600px) {\n  .salvage-modal-content {\n    /* Keep the salvage modal a centered card even where the scheduler modal\n       goes full-screen. */\n    width: 90%;\n    height: auto !important;\n    max-height: 90vh !important;\n    border-radius: 16px;\n    padding: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
